// extracted by mini-css-extract-plugin
export default {"dualFlags":"_2ERF","primaryFlag":"_1U9n","secondaryFlag":"_3Jt6"};